module.exports = __webpack_public_path__ + "img/icon-information.2d7cbeb3.svg";